import { ProductCard } from '../product-card/product-card';
import { GridLayout } from '../grid-layout/grid-layout';

import { ClientSubcategory } from '@/api/types/products';
import { getCategoryDataTestid } from '@/utils/navigate-to-products';

import styles from './subcategory-products.module.css';
import { useInfo } from '@/app/infoContext';

export const SubcategoryProducts = ({
  subcategory,
  isAvailable,
  withTitle = true,
}: {
  subcategory: ClientSubcategory;
  isAvailable?: boolean;
  withTitle?: boolean;
}) => {
  const { isMobile } = useInfo();


  const Content = () => {
    return (
      <GridLayout display={isMobile ? 'flex' : 'grid'}>
        {subcategory.products.map((product) => (
          <ProductCard product={product} key={product.id} isAvailable={isAvailable} />
        ))}
      </GridLayout>
    );
  };

  return (
    <div
      className={`${styles.wrapper} ${isMobile ? styles.isMobile : ''}`}
      data-testid={getCategoryDataTestid(subcategory.id)}
      aria-label={subcategory.categoryName}
    >
      {withTitle && <h3 className={styles.title}>{subcategory.categoryName}</h3>}
      <Content />
    </div>
  );
};
